import { Navigate, Outlet } from 'react-router-dom'

import { WorkflowSurveysRootPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { hasSurveysModule } from 'modules/engagement/lib/hasSurveysModule'
import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import PageLoading from 'modules/layout/components/Page/Loading'
import CollectionsBootstrap from 'modules/surveys/lib/CollectionsBootstrap'
import { WorkflowSurveysContext } from 'modules/surveys/lib/WorkflowSurveysContext'

const Container = () => {
  const { getListPath } = useMarketplaceModulesPath()
  const { data, loading } = useQuery(WorkflowSurveysRootPageDocument)

  const moduleAvailabilities = data?.companies.moduleAvailabilities ?? []
  const upsellFlowEnabled = data?.upsell._policies.canRequestUpsell.can ?? false
  const canCreateForms = data?.surveys._policies.createForms.can ?? false
  const canCreateTemplates = data?.surveys._policies.createSurveyTemplates.can ?? false
  const canManageSurveys = data?.surveys._policies.v2ManageSurveys.can ?? false
  const canCreateEverybody = data?.surveys._policies.surveyCreateEverybody.can ?? false
  const canCreateReportees = data?.surveys._policies.surveyCreateReportees.can ?? false

  if (loading) {
    return <PageLoading />
  }

  if (!hasSurveysModule(moduleAvailabilities) && !upsellFlowEnabled) {
    return <Navigate to={getListPath()} />
  }

  return (
    <WorkflowSurveysContext.Provider
      value={{
        moduleAvailabilities,
        upsellFlowEnabled,
        loading,
        canCreateForms,
        canCreateTemplates,
        canManageSurveys,
        canCreateEverybody,
        canCreateReportees,
      }}
    >
      <Outlet />
    </WorkflowSurveysContext.Provider>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
